// Fixed Asset Types State

export default {
  fixedAssetTypesList: [],
  fixedAssetTypeInfo: {},
  fullFixedAssetTypesList: []
}
